'use client';

import React, { forwardRef, useImperativeHandle, useRef } from 'react';

import { MessageInput, type MessageInputHandle } from './MessageInput';

export type ChatComposerProps = {
  disabled?: boolean;
  placeholder?: string;
  maxLength?: number;
  allowFileUpload?: boolean;
  acceptedFileTypes?: string[];
  onSend: (content: string) => void;
  onFileUpload?: (files: File[]) => void;
  className?: string;
  style?: React.CSSProperties;
}

export type ChatComposerHandle = {
  focusInput: () => void;
}

export const ChatComposer = forwardRef<ChatComposerHandle, ChatComposerProps>(function ChatComposer({
  disabled,
  placeholder,
  maxLength,
  allowFileUpload,
  acceptedFileTypes,
  onSend,
  onFileUpload,
  className,
  style
}: ChatComposerProps, ref) {
  const inputRef = useRef<MessageInputHandle>(null);
  useImperativeHandle(ref, () => ({
    focusInput: () => inputRef.current?.focus()
  }), []);
  return (
    <div className={className} style={style}>
      <MessageInput
        ref={inputRef}
        disabled={disabled}
        placeholder={placeholder}
        maxLength={maxLength}
        allowFileUpload={allowFileUpload}
        acceptedFileTypes={acceptedFileTypes}
        onSend={onSend}
        onFileUpload={onFileUpload || (() => {})}
      />
    </div>
  );
});


